import type * as core from '../../../../../../../core'

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'Training Implications by Functional Area',
      type: 'charts',
      content: {
        '{}': {
          data: {
            '[]': [
              {
                '{}': {
                  name: 'Training Implications',
                  values: {
                    '[]': [
                      {
                        '{}': {
                          name: 'Change Impacts',
                          points: {
                            '[]': [
                              {
                                '{}': {
                                  x: 'Build / Functional',
                                  y: {
                                    '#': {
                                      '@': 'buildFunctional',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Data Migration',
                                  y: {
                                    '#': {
                                      '@': 'dataMigration',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Reporting & Analytics',
                                  y: {
                                    '#': {
                                      '@': 'reportingAndAnalytics',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Change Management',
                                  y: {
                                    '#': {
                                      '@': 'changeManagement',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Data Integration',
                                  y: {
                                    '#': {
                                      '@': 'dataIntegration',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Technical',
                                  y: {
                                    '#': {
                                      '@': 'technical',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Project Management',
                                  y: {
                                    '#': {
                                      '@': 'projectManagement',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Marketing Cloud',
                                  y: {
                                    '#': {
                                      '@': 'marketingCloud',
                                    },
                                  },
                                },
                              },
                            ],
                          },
                        },
                      },
                    ],
                  },
                },
              },
            ],
          },
          type: 'bar',
        },
      },
    },
  },
  subqueries: {
    technical: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Technical',
            ],
          },
          {
            '!=': [
              {
                '@.': '!training_implications',
              },
              null,
            ],
          },
          {
            '!=': [
              {
                '@.': '!training_implications',
              },
              '',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    dataMigration: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Data Migration',
            ],
          },
          {
            '!=': [
              {
                '@.': '!training_implications',
              },
              null,
            ],
          },
          {
            '!=': [
              {
                '@.': '!training_implications',
              },
              '',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    marketingCloud: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Marketing Cloud',
            ],
          },
          {
            '!=': [
              {
                '@.': '!training_implications',
              },
              null,
            ],
          },
          {
            '!=': [
              {
                '@.': '!training_implications',
              },
              '',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    buildFunctional: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Build / Functional',
            ],
          },
          {
            '!=': [
              {
                '@.': '!training_implications',
              },
              null,
            ],
          },
          {
            '!=': [
              {
                '@.': '!training_implications',
              },
              '',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    dataIntegration: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Data Integration',
            ],
          },
          {
            '!=': [
              {
                '@.': '!training_implications',
              },
              null,
            ],
          },
          {
            '!=': [
              {
                '@.': '!training_implications',
              },
              '',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    changeManagement: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Change Management',
            ],
          },
          {
            '!=': [
              {
                '@.': '!training_implications',
              },
              null,
            ],
          },
          {
            '!=': [
              {
                '@.': '!training_implications',
              },
              '',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    projectManagement: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Project Management',
            ],
          },
          {
            '!=': [
              {
                '@.': '!training_implications',
              },
              null,
            ],
          },
          {
            '!=': [
              {
                '@.': '!training_implications',
              },
              '',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    reportingAndAnalytics: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Reporting & Analytics',
            ],
          },
          {
            '!=': [
              {
                '@.': '!training_implications',
              },
              null,
            ],
          },
          {
            '!=': [
              {
                '@.': '!training_implications',
              },
              '',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
  },
}
